import { useQuery } from "react-query"
import { request } from "../../utils/axios-utils"

const getAllTypeformResponse = () => {
    return request({ url: `typeform/all-company-questions` })
}

export const useAllTypeformResponse = () => {
    return useQuery(['all-typeform-responses'], getAllTypeformResponse)
}